import { render, staticRenderFns } from "./level-group.vue?vue&type=template&id=4cc37ce8&scoped=true"
import script from "./level-group.vue?vue&type=script&lang=js"
export * from "./level-group.vue?vue&type=script&lang=js"
import style0 from "./level-group.vue?vue&type=style&index=0&id=4cc37ce8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc37ce8",
  null
  
)

export default component.exports